import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DynamicContentsForm from './DynamicContentsForm';
import {
  addDynamicContent,
  updateDynamicContent,
} from 'services/redux/dynamicContents/action';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addDynamicContent,
      updateDynamicContent,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DynamicContentsForm);
